
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vidskiptavinir",
      function () {
        return require("private-next-pages/vidskiptavinir/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vidskiptavinir"])
      });
    }
  